import { useConf } from "../../context/account/paramsAccount";
import RenderModifLine from "./renderModifLine";

const RenderSubcategories = ({
    subcategories,
    detail,
    setDetails,
    depth = 0,
    parentId,
    setIsChecked,
    isChecked,
    details
}: {
    subcategories: any,
    detail: any
    setDetails: any,
    depth: number,
    parentId: any,
    setIsChecked: any,
    isChecked: Boolean,
    details: any
}) => {
    const { conf, setConf }: any = useConf()

    if (!subcategories) return null;
    const isRoot = depth === 0;
    const personnel: any[] = [];
    const consommation: any[] = [];
    const materiel: any[] = [];
    const nested: any[] = [];
    const checkSelect = () => {
        setIsChecked(!isChecked)
    }
    const updateInformationSign = (id: string | boolean, key: string, value: any) => {
        setDetails((prevDetails: any) =>
            prevDetails?.map((phase: any) => ({
                ...phase,
                sous_categorie: phase.sous_categorie.map((sub: any) => {
                    if (sub.rpl_id === id) {
                        return {
                            ...sub,
                            informationSign: {
                                ...sub.informationSign,
                                [key]: value,
                            },
                        };
                    }
                    return sub;
                }),
            }))
        );

        // Mise à jour dans localStorage
        const savedData = localStorage.getItem(`prestaHl_${conf.user.user_code}`);
        let prestas = savedData ? JSON.parse(savedData) : [];
        const updatedPrestas = prestas.map((presta: any) => {
            if (presta.rpl_id === id) {
                return {
                    ...presta,
                    sous_categorie: presta.sous_categorie.map((sub: any) =>
                        sub.rpl_id === id ? { ...sub, sendAllPresta: { ...sub.sendAllPresta, [key]: value } } : sub
                    ),
                };
            }
            return presta;
        });
        localStorage.setItem(`prestaHl_${conf.user.user_code}`, JSON.stringify(updatedPrestas));
    };
    return (
        <>
            {subcategories.map((sub: any) => {
                const hasChildren = sub.sous_categorie && sub.sous_categorie.length > 0;
                if (hasChildren && sub?.rpl_av_id === null) {
                    // On groupe les sous-catégories enfants simples par type
                    const personnel: any[] = [];
                    const consommation: any[] = [];
                    const materiel: any[] = [];
                    const nested: any[] = [];

                    sub?.sous_categorie.forEach((child: any) => {
                        if (child?.sous_categorie?.length) {
                            nested.push(child); // Catégories imbriquées
                        } else {
                            if (child?.v_personnel) personnel.push(child);
                            if (child?.v_consommation) consommation.push(child);
                            if (child?.v_reserve) consommation.push(child);
                            if (child?.v_materiel) materiel.push(child);
                        }
                    });
                    return (
                        <div key={sub.rpl_id}>
                            <p className={`titleCategory`}>{sub?.rpl_designation}</p>
                            {/* Sous-catégories imbriquées */}
                            {nested.length > 0 && (
                                <div className="category_container subcategory">
                                    <RenderSubcategories
                                        subcategories={nested}
                                        detail={detail}
                                        setDetails={setDetails}
                                        depth={depth + 1}
                                        parentId={parentId}
                                        setIsChecked={setIsChecked}
                                        isChecked={isChecked}
                                        details={details}
                                    />
                                </div>
                            )}
                            {consommation?.length > 0 && (
                                <div className="category consommation">
                                    <h4>Consommation</h4>
                                    <div className="subcategorie_container">
                                        {consommation.map((item) => (
                                            <RenderModifLine
                                                key={item.rpl_id}
                                                sub={item}
                                                detail={detail}
                                                setDetails={setDetails}
                                                parentId={parentId}
                                                subcategories={details}
                                            />
                                        ))}
                                    </div>
                                </div>
                            )}
                            {materiel.length > 0 && (
                                <div className="category materiel">
                                    <h4>Matériel</h4>
                                    <div className="subcategorie_container">
                                        {materiel.map((item) => (
                                            <RenderModifLine
                                                key={item.rpl_id}
                                                sub={item}
                                                detail={detail}
                                                setDetails={setDetails}
                                                parentId={parentId}
                                                subcategories={details}
                                            />
                                        ))}
                                    </div>
                                </div>
                            )}
                            <div className="paddingPresta">
                                {personnel.length > 0 && (
                                    <div className="category personnel">
                                        <h4>Personnel</h4>
                                        <div className="subcategorie_container">
                                            {personnel.map((item) => (
                                                <RenderModifLine
                                                    key={item.rpl_id}
                                                    sub={item}
                                                    detail={detail}
                                                    setDetails={setDetails}
                                                    parentId={parentId}
                                                    subcategories={details}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                } else {
                    // Élément individuel sans sous-catégorie
                    return (
                        <div key={sub.rpl_id} className="paddingPresta">
                            <RenderModifLine
                                sub={sub}
                                detail={detail}
                                setDetails={setDetails}
                                parentId={parentId}
                                subcategories={subcategories} />
                        </div>
                    );
                }
            })}

        </>
    );
};
export default RenderSubcategories